import React from 'react';
import { Box, Container, Heading, Text, VStack, Stack, HStack, Icon, Badge } from '@chakra-ui/react';
import { motion } from 'framer-motion';
import { FaCheckCircle } from 'react-icons/fa';

const MotionBox = motion(Box);

const ExperiencedCurriculum = ({ data }) => {
  return (
    <Box py={{ base: 16, md: 20 }} bg="brand.50">
      <Container maxW="container.xl">
        <VStack spacing={12}>
          <VStack spacing={4} textAlign="center">
            <Heading size="2xl" fontWeight="900" color="brand.800">
              {data.title}
            </Heading>
            <Text fontSize="lg" color="brand.500" maxW="2xl">
              {data.description}
            </Text>
          </VStack>


<VStack spacing={6} w="full" align="stretch">
  {data.weeks.map((week, index) => (
    <MotionBox
      key={index}
      initial={{ opacity: 0, x: -30 }}
      whileInView={{ opacity: 1, x: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6, delay: index * 0.1 }}
    >
      <Box
        p={8}
        bg="white"
        borderRadius="2xl"
        boxShadow="0 4px 20px rgba(0,0,0,0.08)"
        _hover={{
          transform: 'translateX(8px)',
          boxShadow: '0 12px 40px rgba(16,185,129,0.2)',
        }}
        transition="all 0.3s"
      >
        {/* Change HStack to VStack for mobile, HStack for desktop */}
        <Stack 
          direction={{ base: 'column', md: 'row' }} 
          align={{ base: 'start', md: 'start' }}
          spacing={6}
        >
          <Badge
            px={4}
            py={2}
            bg="accent.green"
            color="white"
            fontSize="md"
            fontWeight="700"
            borderRadius="xl"
            minW="120px"
            textAlign="center"
            alignSelf={{ base: 'start', md: 'start' }}
          >
            {week.weeks}
          </Badge>
          
          <VStack align="start" flex={1} spacing={3}>
            <Heading size="lg" color="brand.700">
              {week.title}
            </Heading>
            
            <VStack align="start" spacing={2}>
              {week.topics.map((topic, idx) => (
                <HStack key={idx} spacing={3}>
                  <Icon as={FaCheckCircle} color="accent.green" />
                  <Text color="brand.600">{topic}</Text>
                </HStack>
              ))}
            </VStack>
          </VStack>
        </Stack>
      </Box>
    </MotionBox>
  ))}
</VStack>

          
        </VStack>
      </Container>
    </Box>
  );
};

export default ExperiencedCurriculum;